(function () {
  class FeatureOutroPopup extends PIXI.Container {
    constructor() {
      super();

      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
      Reflex.registerEventHandler(
        "orientationChange",
        this.onOrientationChange.bind(this)
      );

      this.visible = false;
    }

    initialise() {
      this._popupMaskDimObject = resourceManager.get("popupMaskDimObject");

      this._outroPopupWin = resourceManager.get(
        "featurePopupContainer:freespinsOutroWinPopup"
      );
      this._outroPopupWin.visible = false;
      this._outroPopupCloseButton = resourceManager.get(
        "featurePopupContainer:freespinsOutroWinPopup:bg:continueButton"
      );
      this._outroPopupWinValue = resourceManager.get(
        "featurePopupContainer:freespinsOutroWinPopup:bg:win"
      );
    }

    onGameConfigEvent() {
      this.initialise();
    }

    onOrientationChange() {
      if (this._active) {
        this.visible = true;
      }
    }

    initShowPopup(win, touchCallback) {
      this._active = true;

      const self = this;
      this._outroPopupCloseButton.touchend =
        this._outroPopupCloseButton.mouseup = function () {
          self._outroPopupCloseButton.interactive = false;
          self._outroPopupCloseButton.touchend =
            self._outroPopupCloseButton.mouseup = function () {};
          self._popupMaskDimObject.show(false);

          touchCallback();
        };
      this._outroPopupWinValue.setText(gdk.formatCurrency(win));
      this.visible = true;
      this.alpha = 0;
    }

    showPopupProgress(progress) {
      this.alpha = progress;
      this._popupMaskDimObject.show(true, progress);
    }

    showPopupFinished(show) {
      this.alpha = 1;
      this.visible = show;
      this._popupMaskDimObject.show(show, 1);
      this._outroPopupCloseButton.interactive = show;
      if (!show) {
        this._active = false;
      }
    }
  }

  var featureOutroPopupCreator = function (json) {
    return new FeatureOutroPopup();
  };

  var featureOutroPopupInitialiser = function (json, buggy) {};

  var featureOutroPopupFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "featureOutroPopup",
    featureOutroPopupCreator,
    featureOutroPopupInitialiser,
    featureOutroPopupFilesRequired
  );
})();
